// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'E:/work/楼下元擎合并新代码/paas_backend_admin/node_modules/@ant-design/icons/es/icons/SmileOutlined';
export default { SmileOutlined };
